
import React from "react";

import s from './index.module.scss';

interface ItemProps {
  title: string
  number: string
  icon: string
}

const Item: React.FC<ItemProps> = ({
  title, number = 10, icon
}) => {

  return <>
    <div className={s.itemWrap}>
      <img className={s.icon} src={icon} alt="" />
      <div className={s.descWrap}>
        <div className={s.text}>{title}</div>
        <div className={s.number}>{number}</div>
      </div>
    </div>
  </>
}


export default React.memo(Item);